"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleStateTypes = void 0;
exports.CollectibleStateTypes = ['none', 'found'];
